<mat-nav-list class="avatar">
  <div class="flex align-center justify-space-between my-1 pl-2 pr-8 pt-2" >
    <div class="flex align-center">
      <app-icon class="d-inline align-center" size="xs" name="global"></app-icon>
      <span class="avatar__list-item m-2" >{{ 'layout.header.userMenu.changeLanguage' | translate}}</span>
    </div>
    <div>
      <button mat-flat-button *ngIf="currentLang === language.Arabic" (click)="setLanguage(language.English)" class="btn-secondary">
        <span class="weight-medium d-inline-block mr-2">{{ "Lang.EN" | translate}}</span>
        <app-icon class="d-inline align-center" size="xs" name="saudi-flag"></app-icon>
      </button>

      <button mat-flat-button *ngIf="currentLang === language.English" (click)="setLanguage(language.Arabic)" class="btn-secondary">
        <span class="weight-medium d-inline-block mr-2">{{ "Lang.AR" | translate}}</span>
        <app-icon class="d-inline align-center" size="xs" name="saudi-flag"></app-icon>
      </button>
    </div>
  </div>
  <app-nav-list     
  [menuList]="navigationItems" color="basic" [divider]="true" (action)="navService.action$.next($event)"></app-nav-list>
</mat-nav-list>
